"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useContractorFiltersStore } from "@/store/store";
import { useContractorProfiles } from "../_hooks/useContractorProfiles";
import { useDebounce } from "../_hooks/useDebounce";
import { getSurveyPropertyTypeFilter } from "../_utils/getSurveyPropertyTypeFilter";
const ContractorsQueryContext = createContext(null);

// Owns the search input + the real listing query so ContractorsListHeader
// (search box), ContractorsListSummary (result count) and ContractorsList
// (the cards) — three separate sibling components — can all read/drive the
// same /v2/api/lead-gen/profiles request. Filter chips don't need to live
// here: they're already shared via useContractorFiltersStore.
export function ContractorsQueryProvider(t0) {
  const $ = _c(7);
  const {
    children,
    initialPage
  } = t0;
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  const query = useContractorProfiles(debouncedSearchQuery, initialPage);
  let t2;
  if ($[1] !== query || $[2] !== searchQuery) {
    t2 = {
      searchQuery,
      setSearchQuery,
      ...query
    };
    $[1] = query;
    $[2] = searchQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const value = t2;
  let t3;
  if ($[4] !== children || $[5] !== value) {
    t3 = <ContractorsQueryContext.Provider value={value}>{children}</ContractorsQueryContext.Provider>;
    $[4] = children;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp() {
  const surveyPropertyType = getSurveyPropertyTypeFilter();
  if (!surveyPropertyType) {
    return;
  }
  const {
    appliedFilters,
    setAppliedFilters
  } = useContractorFiltersStore.getState();
  if (appliedFilters.selected.propertyType?.length) {
    return;
  }
  setAppliedFilters({
    ...appliedFilters,
    selected: {
      ...appliedFilters.selected,
      propertyType: [surveyPropertyType]
    }
  });
}
export function useContractorsQuery() {
  const context = useContext(ContractorsQueryContext);
  if (!context) {
    throw new Error("useContractorsQuery must be used within a ContractorsQueryProvider");
  }
  return context;
}